// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var Select = require("@mui/material/Select").default;
var MenuItem = require("@mui/material/MenuItem").default;
var InputLabel = require("@mui/material/InputLabel").default;
var FormControl = require("@mui/material/FormControl").default;

function strToBool(str) {
  switch (str) {
    case "false" :
        return false;
    default:
      return true;
  }
}

function boolToStr(b) {
  return Expln_utils_common.stringify(b);
}

function MM_cmp_edit_stmts_setting(props) {
  var onChange = props.onChange;
  var longClickEnabled = props.longClickEnabled;
  var editStmtsByLeftClick = props.editStmtsByLeftClick;
  var leftClickDescrStr = longClickEnabled ? "Short click (Left click)" : "Left click";
  var altLeftClickDescrStr = longClickEnabled ? "Long click (Alt + Left click)" : "Alt + Left click";
  return React.createElement(Expln_React_Column.make, {
              spacing: 0,
              children: Caml_option.some(null)
            }, React.createElement(Expln_React_Row.make, {
                  alignItems: "center",
                  children: Caml_option.some(null)
                }, React.createElement(FormControl, {
                      size: "small",
                      children: Caml_option.some(null)
                    }, React.createElement(InputLabel, {
                          id: "label-for-edit-statements-by",
                          children: "Edit statements by"
                        }), React.createElement(Select, {
                          sx: {
                            width: 250
                          },
                          labelId: "label-for-edit-statements-by",
                          label: "Edit statements by",
                          value: Expln_utils_common.stringify(editStmtsByLeftClick),
                          onChange: Expln_React_common.evt2str(function (boolStr) {
                                onChange(strToBool(boolStr));
                              }),
                          children: Caml_option.some(null)
                        }, React.createElement(MenuItem, {
                              value: "true",
                              children: Caml_option.some(leftClickDescrStr)
                            }), React.createElement(MenuItem, {
                              value: "false",
                              children: Caml_option.some(altLeftClickDescrStr)
                            }))), React.createElement(FormControl, {
                      size: "small",
                      children: Caml_option.some(null)
                    }, React.createElement(InputLabel, {
                          id: "label-for-select-statements-by",
                          children: "Select statements by"
                        }), React.createElement(Select, {
                          sx: {
                            width: 250
                          },
                          labelId: "label-for-select-statements-by",
                          label: "Select statements by",
                          value: Expln_utils_common.stringify(!editStmtsByLeftClick),
                          onChange: Expln_React_common.evt2str(function (boolStr) {
                                onChange(!strToBool(boolStr));
                              }),
                          children: Caml_option.some(null)
                        }, React.createElement(MenuItem, {
                              value: "true",
                              children: Caml_option.some(leftClickDescrStr)
                            }), React.createElement(MenuItem, {
                              value: "false",
                              children: Caml_option.some(altLeftClickDescrStr)
                            })))), React.createElement("span", {
                  style: {
                    color: "grey",
                    fontSize: "12px"
                  }
                }, "On some keyboards 'Alt' is labelled as 'Opt'"));
}

var make = MM_cmp_edit_stmts_setting;

exports.strToBool = strToBool;
exports.boolToStr = boolToStr;
exports.make = make;
/* react Not a pure module */
